var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "telegram_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7502"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18867"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18721"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#telegram_svg__a)",
  "data-name": "Group 18720"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.374 14.232Q18.26 15.528 8.933 19.6q-1.516.6-1.585 1.179c-.082.65.731.905 1.838 1.253q.227.075.467.149a15.3 15.3 0 0 0 3.316.785 4.05 4.05 0 0 0 2.317-.853q8.716-5.884 9-5.948a.5.5 0 0 1 .443.042.44.44 0 0 1 .1.378 60 60 0 0 1-4.929 4.842c-.514.479-.88.82-.954.9-.167.175-.338.339-.5.5-1.014.975-1.772 1.706.041 2.9.87.574 1.568 1.05 2.263 1.523.76.518 1.518 1.032 2.5 1.676.25.164.488.334.722.5a4.06 4.06 0 0 0 2.659 1.106c.569-.053 1.158-.588 1.463-2.188.707-3.779 2.1-11.964 2.418-15.338a3.8 3.8 0 0 0-.036-.84.9.9 0 0 0-.3-.577 1.4 1.4 0 0 0-.827-.244c-.812 0-2.043.429-7.968 2.893Z",
  "data-name": "Path 27262"
}))))));
export { SvgTelegram as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.ccab3ef40c1b7dee74e7d4e5eedf27ca.svg";